import { render, staticRenderFns } from "./increase-pair-amount-dialog.vue?vue&type=template&id=12c0252c&scoped=true&"
import script from "./increase-pair-amount-dialog.vue?vue&type=script&lang=ts&"
export * from "./increase-pair-amount-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./increase-pair-amount-dialog.vue?vue&type=style&index=0&id=12c0252c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0252c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VChipGroup,VDialog,VIcon,VImg,VSheet,VTextField,VTooltip})
